import { __callbacks } from "../Callbacks/Callback";
import { __chats } from "../Chats/Chats";
import { __debug } from "../Debug/Debug";
import { IChatMsgAPI } from "../Interfaces";


export namespace ExplorerAPI {

    export class MsgReceive {
        constructor(chatMsg: IChatMsgAPI) {
            // validate chat id
            const chatIds = __chats.getIds().filter(chatId => chatId === chatMsg.chatId);
            if(chatIds.length === 0) {
            __debug.warn(() => {
                console.warn(`[MsgReceive]::No Chat exists with chatId: [${chatMsg.chatId}]`);
            });
                return;
            }
            __callbacks.chatMsgReceive.trigger({ ...chatMsg });
        }
    }

    export class MsgForm {
        constructor(chatMsg: IChatMsgAPI) {
            new MsgReceive(chatMsg);
        }
    }
}